import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';

/**
 * SECTION 5: CO APPLICANT EMERGENCY CONTACT INFORMATION
 */
export function getCoApplicantEmergencyContactsFields(options: DetailsFormOptions): FormlyFieldConfig[] {
	return [
		// Emergency Contacts
		{
			key: 'Co_Applicant_EC',
			type: 'repeat-ec',
			props: {
				label: 'Emergency contacts',
				addText: 'Add Emergency Contact',
				addIcon: 'person_add',
				onToggleComplete: (ec: any, complete: boolean) => options.onToggleECComplete(ec, complete, 'Co_Applicant_EC'),
				emptyMessage: 'No emergency contacts added yet',
			},
			fieldArray: {
				fieldGroupClassName: 'row panel-small',
				fieldGroup: [
					{
						className: 'col-12 col-sm-6 col-md-4',
						key: 'Name1',
						type: 'input',
						props: {
							label: 'Name',
							required: true,
						},
					},
					{
						className: 'col-12 col-sm-6 col-md-4',
						key: 'Relation_to_Applicant',
						type: 'input',
						props: {
							label: 'Relationship',
							required: true,
						},
					},
					{
						className: 'col-12 col-sm-6 col-md-4',
						key: 'Phone_Number',
						type: 'phone',
						props: {
							label: 'Phone',
							required: true,
						},
					},
				],
			},
		},
	];
}